import { inject, observer } from "mobx-react";
import { type FunctionComponent } from "react";
import { compose } from "nvent-web/utils/compose";

import AppStore from "nvent-web/stores/App";
import { type LocaleString } from "nvent-web/types/LocaleString";

interface TranslatedStringProps {
  value: LocaleString;
}

interface TranslatedStringPropsInner extends TranslatedStringProps {
  app: AppStore;
}

const TranslatedString: FunctionComponent<TranslatedStringPropsInner> = ({
  app,
  value,
}) => {
  return <span>{value[app.locale]}</span>;
};

const TranslatedStringComponent = compose<TranslatedStringProps>(
  inject("app"),
  observer
)(TranslatedString);

TranslatedStringComponent.displayName = "TranslatedString";

export default TranslatedStringComponent;
